import { createActions, Store } from 'reflux'
import jwtDecode from 'jwt-decode'
import Raven from 'raven-js'
import LoopApi from '/helpers/LoopApi'

export var AuthActions = createActions([
	'SetTokens',
	'SetJwt',
	'ClearJwt',
	'IntendedJoin',
	'SetExternalToken',
	'RemoveExternalToken',
	'TryRefreshToken',
])

export class AuthStore extends Store {
	constructor() {
		super()
		this.state = {
			jwt: null,
			intended_join: null,
			external_tokens: JSON.parse(sessionStorage.external_tokens || '{}'),
		}
		this.listenables = AuthActions
	}

	onSetTokens(external_tokens = {}) {
		this.setState({
			external_tokens: {
				...this.state.external_tokens,
				...external_tokens,
			},
		})
	}

	onSetExternalToken(strategy, access_token, refresh_token = null) {
		const external_tokens = { ...this.state.external_tokens }
		external_tokens[strategy] = access_token
		this.setState({ external_tokens })

		LoopApi(null, 'SetToken', { strategy, refresh_token, access_token })

		sessionStorage.external_tokens = JSON.stringify(external_tokens)
	}

	onRemoveExternalToken(strategy, skip_request = false) {
		!skip_request && LoopApi(null, 'RemoveToken', { strategy })
		const external_tokens = { ...this.state.external_tokens }
		delete external_tokens[strategy]
		this.setState({ external_tokens })
		sessionStorage.external_tokens = JSON.stringify(external_tokens)
	}

	async onTryRefreshToken(strategy) {
		try {
			const result = await LoopApi(null, 'RefreshToken', { strategy })
			if (result.error) {
				return console.error(result)
			}
			if (!result) {
				this.onRemoveExternalToken(strategy, true)
			}
			const external_tokens = {
				...this.state.external_tokens,
				[strategy]: result.token,
			}
			this.setState({ external_tokens })
			sessionStorage.external_tokens = JSON.stringify(external_tokens)
		} catch (e) {
			console.error(e)
		}
	}

	onIntendedJoin(meeting_name) {
		this.setState({
			intended_join: meeting_name,
		})
	}

	onSetJwt(passedJwt = null) {
		let jwt = passedJwt || localStorage.getItem('token')
		if (!jwt) {
			return
		}

		try {
			const decoded = jwtDecode(jwt)
			if (decoded.exp && Math.floor(Date.now() / 1000) > decoded.exp) {
				localStorage.removeItem('token')
				this.setState({ jwt: null })
				return location.reload()
			}
			this.setState({ jwt: decoded })

			const raven_data = {
				username: decoded.data.username,
				email: decoded.data.email,
				created_at: decoded.data.created_at,
				type: decoded.data.type,
				verified: decoded.data.verified,
				id: decoded.data._id,
			}
			Raven.setUserContext(raven_data)
		} catch (err) {
			localStorage.removeItem('token')
			this.setState({ jwt: null })
			console.error(err)
			location.reload()
		}
	}

	onClearJwt() {
		localStorage.removeItem('token')
		localStorage.removeItem('external_tokens')
		this.setState({ jwt: null })
	}
}

AuthStore.id = 'auth'
